/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon, Input } from 'components/common';
import * as styles from './Sidebar.styles';

const COLLAPSED_KEY = 'filterPanelCollapsed';

const readCollapsed = () => {
  try {
    return window.localStorage.getItem(COLLAPSED_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

const Sidebar = ({ search, activeCount, children }) => {
  const [isCollapsed, setCollapsed] = useState(readCollapsed);

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      try {
        window.localStorage.setItem(COLLAPSED_KEY, String(!prev));
      } catch (e) {
        // Storage can be unavailable (private mode); the toggle still works for this visit.
      }
      return !prev;
    });
  };

  const badge = activeCount > 0 && <span css={styles.badgeStyles}>{activeCount}</span>;

  if (isCollapsed) {
    return (
      <aside css={styles.railStyles}>
        <button type="button" css={styles.railButtonStyles} onClick={toggleCollapsed} title="Show filters">
          <Icon name="filter" />
          {badge}
        </button>
      </aside>
    );
  }

  return (
    <aside css={styles.sidebarStyles}>
      <div css={styles.headerStyles}>
        <div css={styles.headerTitleStyles}>
          <Icon name="filter" />
          <span>Filters</span>
          {badge}
        </div>
        <button type="button" css={styles.collapseButtonStyles} onClick={toggleCollapsed} title="Hide filters">
          <Icon name="angle-double-left" />
        </button>
      </div>
      {
        search && (
          <form css={styles.searchFormStyles} onSubmit={search.onSubmit}>
            <Icon name="search" styles={styles.searchIconStyles} />
            <Input
              type="text"
              name={search.name}
              value={search.value}
              onChange={search.onChange}
              placeholder={search.placeholder}
              styles={styles.searchInputStyles}
              labelStyles={styles.hiddenLabelStyles}
            />
          </form>
        )
      }
      <div css={styles.sidebarContainerStyles}>
        {children}
      </div>
    </aside>
  );
};

Sidebar.propTypes = {
  search: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  }),
  activeCount: PropTypes.number,
  children: PropTypes.node.isRequired,
};

Sidebar.defaultProps = {
  search: null,
  activeCount: 0,
};

export default Sidebar;
